<template>
  <modal :show="show" @change="$emit('change',$event)" width="550" :headerClass="currentLocale === 'ru' ? 'bg-main-orange white--text helvetica-roman fs-18' : 'bg-main-orange white--text rubik-medium fs-18'">
    <template v-slot:header>
      <span>{{$t('modals.modalIndicationHighCurrentValue.title')}}</span>
    </template>
    <template v-slot:main>
      <div class="mt-0 mb-4 pl-4 pr-4">
        <p class="text-center pt-4 mb-0">{{$t('modals.modalIndicationHighCurrentValue.infoPart1')}} <strong>{{$t('modals.modalIndicationHighCurrentValue.infoPart2')}}</strong></p>
        <p class="text-center mb-0">{{$t('modals.modalIndicationHighCurrentValue.infoPart3')}} <strong>{{$t('modals.modalIndicationHighCurrentValue.infoPart4')}} </strong> <a href="https://tatenergosbyt.ru/about/press/news/diff-tarify-dlya-naseleniya/">({{$t('modals.modalIndicationHighCurrentValue.infoPart5')}})</a></p>
      </div>
      <div class="d-flex justify-center pb-2" style="gap: 12px">
        <v-btn class="orange-btn px-12 py-3" x-small outlined @click="onSave">{{$t('modals.modalIndicationHighCurrentValue.saveButton')}}</v-btn>
        <v-btn class="orange-btn px-12 py-3" x-small outlined @click="onCancel">{{$t('modals.modalIndicationHighCurrentValue.resetButton')}}</v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../common/Modal';
  import { mapGetters } from "vuex";


  export default {
    name: "ModalIndicationHighCurrentValue",
    components: { Modal },
    model: {
      prop: 'show',
      event: 'change'
    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeModal() {
        this.$emit('change', false);
      },
      onSave() {
        this.$emit('save-indication');
      },
      onCancel() {
        this.$emit('cancel-indication');
      }
    },
    computed: {
      ...mapGetters("locale",["currentLocale"]),
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/_variables.scss';

  .orange-btn {
    border-color: $main-orange;
    color: #000;
    font-size: medium;
    text-transform: none;
  }
</style>
